import styled from 'styled-components'

// A table wider than the message column scrolls inside this wrapper rather
// than stretching the conversation panel.
export const ConversationMarkdownTableScrollStyled = styled.div`
  max-width: 100%;
  overflow-x: auto;
`
